import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const dashboardRoutesDictionary = moduleRouteDictionaryFactory(
  'dashboard',
  'dashboard',
  {
    list: 'list',
  },
);
